export const getTemplateFormCollectionFieldOptions = (templateCollection, collections) => {
  if (!templateCollection) return [];
  const { fields, typesenseMapping } = templateCollection;
  return fields
    ? fields
        .filter((field) =>
          typesenseMapping.some((mapping) => mapping.fieldName === field.fieldName),
        )
        .map((item) => ({
          fieldName: item.fieldName,
          fieldTitle: item.fieldTitle.en,
        }))
    : [];
};
